<template>
<div class="map-ui-container">
  <div class="map-ui-controls">
    <div class="mapboxgl-ctrl">
      <button @click="$emit('zoom', 'in')" @mouseover="showTooltip('Zoom in', $event.currentTarget)">
        <v-icon color="#235592">mdi-magnify-plus-outline</v-icon>
      </button>
    </div>

    <div class="mapboxgl-ctrl">
      <button @click="$emit('zoom', 'out')" @mouseover="showTooltip('Zoom out', $event.currentTarget)">
        <v-icon color="#235592">mdi-magnify-minus-outline</v-icon>
      </button>
    </div>

    <!-- <div class="mapboxgl-ctrl filter">
      <button @click="mapFilter" @mouseover="showTooltip('Filter layers', $event.currentTarget)">
        <v-icon color="#235592">mdi-layers</v-icon>
      </button>             
    </div> -->
  </div>

  <div class="map-ui-refresh">
    <div class="mapboxgl-ctrl">
      <button  @click="$emit('zoom', 'reset')" @mouseover="showTooltip('Reset map view', $event.currentTarget)">
        <v-icon color="#235592">mdi-refresh</v-icon>
      </button>       
    </div>
  </div>

  <div :class="mapInstructionClasses">
    <img v-if="this.$vuetify.breakpoint.mdAndUp" src="@/assets/map/map-click-icon.svg" class="mr-2" />
    <img v-if="this.$vuetify.breakpoint.smAndDown" src="@/assets/map/map-tap-icon-mobile.svg" class="mr-2" />    
    <p class="text-body text-center text--fes-blue mb-0">
      {{ this.$vuetify.breakpoint.mdAndUp ? 'Click' : 'Tap' }} on a city to start exploring
    </p>
  </div>  

  <div class="map-ui-tooltip">
    <p class="text-body mb-0">
      {{ tooltipUI }}
    </p>
  </div>    
</div>
</template>

<script>
export default {
  name: 'MapUI', 
  computed: {
    mapInstructionClasses() {
      return {
        'map-ui-instruction --desktop': this.$vuetify.breakpoint.mdAndUp,
        'map-ui-instruction --mobile': this.$vuetify.breakpoint.smAndDown,
      };
    },
  },
  data() {
    return {
      tooltipUI: '',
    }
  },
  methods: {
    showTooltip(content, target) {
      this.tooltipUI = content;
      const top = target.getBoundingClientRect().top - 4; // minus 4 coz of box margin
      document.querySelector('.map-ui-tooltip').style.display = 'block';
      document.querySelector('.map-ui-tooltip').style.top = top + 'px';

      setTimeout(function() { 
        document.querySelector('.map-ui-tooltip').style.display = 'none'
      }, 5000);      
    },
    mapFilter() {
      this.$emit('zoom', 'filter');

      const filterButtonClass = document.querySelector('.mapboxgl-ctrl.filter').classList;
      filterButtonClass.contains('activeFilter') ? 
      filterButtonClass.remove('activeFilter') : 
      filterButtonClass.add("activeFilter");
    }      
  },
};
</script>

<style lang="scss" scoped>
.map-ui-container {
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}
.map-ui-controls {
  position: absolute;
  top: calc(69px + 32px);
  right: 32px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    right: 16px;
    top: calc(69px + 20px + 56px);
  }    
  .mapboxgl-ctrl {
    border-radius: unset !important;
    background-color: rgba(250, 250, 250, 0.9);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);     
    padding: 4px;
    margin-bottom: 4px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin-bottom: 12px;
    }        
    // border: 1px solid rgba(209, 209, 209, 0.4);
    // >>> button + button {
    //   border-top: 1px solid rgba(209, 209, 209, 0.4);    
    // }
  }

  .activeFilter {
    background-color: #B55299;
    .v-icon {
      color: #FFFFFF !important;
    }
  }  
}

.map-ui-refresh {
  position: absolute;
  bottom: 32px;
  right: 32px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    right: 16px;
    bottom: 84px;
  }    
  .mapboxgl-ctrl {
    border-radius: unset !important;
    background-color: rgba(250, 250, 250, 0.9);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);     
    padding: 4px;
    margin-bottom: 4px;
  }
}

.map-ui-instruction {
  position: absolute;
  background-color: rgba(250, 250, 250, 0.9);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px); 
   
  p {
    display: inline-block;
  }

  img {
    vertical-align: middle;
  }

  &.--desktop {
    top: calc(69px + 32px);
    left: 0;
    padding: 32px 32px 32px 64px;
  }

  &.--mobile {
    top: calc(68px);
    left: 50%;
    transform: translate(-50%, 0); 
    padding: 16px 0;
    width: calc(100vw - 16px - 16px);
    display: flex;
    justify-content: center;    
  }  
}

.map-ui-tooltip {
  position: absolute;
  top: calc(69px + 32px);
  right: 72px;  
  padding: 12px;
  color: rgba(250, 250, 250, 0.9);
  background-color: #B55299;
  display: none;
}

.map-ui-tooltip:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 8px solid #B55299;
  border-right: 8px solid transparent;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  right: -16px;
}
</style>
